// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a user loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/app/customers/:id\",\"regex\":\"^/app/customers/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/app/settings/organization/roles/:roleId\",\"regex\":\"^/app/settings/organization/roles/([^/]+)$\",\"paramNames\":[\"roleId\"],\"hasOptionalPrefix\":false},{\"path\":\"/app/support-authenticated/:id\",\"regex\":\"^/app/support-authenticated/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/authenticate/:slug*?\",\"regex\":\"^/authenticate(?:/(.*))?$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/app/announcements\"},{\"path\":\"/app/cards\"},{\"path\":\"/app/cards/accounts\"},{\"path\":\"/app/cards/transactions\"},{\"path\":\"/app/changelog\"},{\"path\":\"/app/customers\"},{\"path\":\"/app/home\"},{\"path\":\"/app/keys\"},{\"path\":\"/app/payments/history\"},{\"path\":\"/app/payments/payment-routes\"},{\"path\":\"/app/reporting\"},{\"path\":\"/app/settings\"},{\"path\":\"/app/settings/organization/approvals\"},{\"path\":\"/app/settings/organization/billing\"},{\"path\":\"/app/settings/organization/fixed-trade-rates\"},{\"path\":\"/app/settings/organization/issuance-rewards\"},{\"path\":\"/app/settings/organization/login\"},{\"path\":\"/app/settings/organization/payouts\"},{\"path\":\"/app/settings/organization/roles\"},{\"path\":\"/app/settings/organization/team\"},{\"path\":\"/app/settings/personal/2fa\"},{\"path\":\"/app/settings/personal/personalization\"},{\"path\":\"/app/settings/personal/profile\"},{\"path\":\"/app/settings/product/crypto-return-policy\"},{\"path\":\"/app/settings/product/email-customization\"},{\"path\":\"/app/settings/product/events\"},{\"path\":\"/app/settings/product/webhooks\"},{\"path\":\"/app/status\"},{\"path\":\"/app/support\"},{\"path\":\"/app/tasks\"},{\"path\":\"/app/wallets\"},{\"path\":\"/app/wallets/customer_wallets\"},{\"path\":\"/app/wallets/developer_wallets\"},{\"path\":\"/app/wallets/overview\"},{\"path\":\"/authenticate/mfa\"},{\"path\":\"/authenticate/select-org\"},{\"path\":\"/error\"},{\"path\":\"/frozen\"},{\"path\":\"/get-started\"},{\"path\":\"/login\"},{\"path\":\"/otp-confirm\"},{\"path\":\"/unauthorized\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.5";import {
  composeBeforeSend,
  filterBrowserExtensionErrors,
  filterGenericRscErrors,
  filterNetworkErrors,
  filterUnauthorizedErrors,
  registerReporter,
} from '@bridge/utils/sentry';
import * as Sentry from '@sentry/nextjs';

import env from './lib/env';

import './lib/datadog';

registerReporter(Sentry);

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

Sentry.init({
  dsn: env.NEXT_PUBLIC_SENTRY_DSN,

  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
  enabled: process.env.NODE_ENV === 'production',

  // Browser-extension noise, transient network failures, generic RSC wrappers
  // (the real error is captured server-side via onRequestError), and
  // expired-session 401s (`session_not_found` or a `Bad Session Token` message —
  // other 401s are still reported). Must stay in sync with sentry.server.config.ts,
  // which drops the same sessions (BRIDGE-DASHBOARD-177).
  beforeSend: composeBeforeSend(
    filterBrowserExtensionErrors,
    filterNetworkErrors,
    filterGenericRscErrors,
    filterUnauthorizedErrors
  ),
});
